.ux-tab-container {
  display: block;
  position: relative;

  &__tab-header {
    @include justify-content($tabAlignment);

    align-items: stretch;
    border-bottom: 1px solid $color-gray-25;
    display: flex;
    max-width: 100%;
  }

  &__tab-body {
    padding-top: $tab-container-padding-vertical;

    &--no-gutter {
      padding-top: 0;
    }
  }

  &__tab-list {
    align-items: flex-start;
    display: flex;
    flex: 1;
    transition: transform 0.3s ease-in-out;
    width: auto;
  }

  &__arrow {
    align-items: center;
    background: $color-white;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    top: 0;
    width: 30px;
    z-index: $z-index-tab-navigation-arrow;

    .ux-icon {
      transition: opacity 0.3s;
    }

    &--right {
      background: linear-gradient(
        to right,
        transparentize($color-white, 0.9999),
        $color-white 18%
      );
      justify-content: flex-end;
      right: 0;
    }

    &--right.is-overlapping {
      background: linear-gradient(
        to right,
        transparentize($color-white, 0.9999),
        $color-white 35%
      );
    }

    &--left {
      background: linear-gradient(
        to left,
        transparentize($color-white, 0.9999),
        $color-white 18%
      );
      justify-content: flex-start;
      left: 0;
    }

    &--left.is-overlapping {
      background: linear-gradient(
        to left,
        transparentize($color-white, 0.9999),
        $color-white 35%
      );
    }

    &::before {
      content: "";
      height: 100%;
      pointer-events: none;
      position: absolute;
      transition: opacity 0.5s ease;
      width: 10px;
      z-index: -1;
    }

    &.is-overlapping::before {
      width: 34px;
    }

    &--left::before {
      background: linear-gradient(
        to left,
        transparentize($color-white, 0.9999),
        $color-white 80%,
        $color-white 100%
      );
      left: 20px;
    }

    &--right::before {
      background: linear-gradient(
        to right,
        transparentize($color-white, 0.9999) 0,
        $color-white 80%,
        $color-white 100%
      );
      right: 20px;
    }
  }

  &__arrow--deactivated {
    .ux-icon {
      opacity: 0.3;
    }
  }

  .ux-tab-button__label {
    white-space: nowrap;
  }

  &--arrows-active {
    .ux-tab-container__tab-header {
      max-width: 100%;
      overflow: hidden;
      position: relative;
    }

    .ux-tab-container__tab-list {
      justify-content: space-between;
      margin-left: 30px;
      margin-right: 30px;
    }
  }

  .ux-tab-container__tab-header--fixed {
    background: $color-white;
    left: 50%;
    position: fixed;
    top: 0;
    transform: translateX(-50%);
    width: 100%;
    z-index: $z-index-tab-header-fixed-top;
  }
}
